export enum ResourcesSuggestions {
  StackId = "stack",
  StackName = "stackName",
  Parent = "parent",
  Provider = "provider",
  Drifted = "drifted",
  Label = "label",
  Space = "space",
  EntityId = "id",
  ResourcesCount = "count",
  ResourceType = "type",
  ResourceAddress = "address",
  ResourceName = "resourceName",
  Vendor = "vendor",
  UpdatedAt = "updatedAt",
}

export const SEARCH_MANAGED_ENTITIES_SUGGESTIONS_DICTIONARY: Record<string, string> = {
  [ResourcesSuggestions.Parent]: "parent entity",
  [ResourcesSuggestions.Provider]: "provider",
  [ResourcesSuggestions.StackId]: "stack",
  [ResourcesSuggestions.StackName]: "stack name",
  [ResourcesSuggestions.ResourceAddress]: "resource address",
  [ResourcesSuggestions.ResourceType]: "resource type",
  [ResourcesSuggestions.Drifted]: "drifted",
  [ResourcesSuggestions.Space]: "space",
  [ResourcesSuggestions.Vendor]: "vendor",
  [ResourcesSuggestions.UpdatedAt]: "updated at",
};
